<script setup>
import Swal from 'sweetalert2';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.onmouseenter = Swal.stopTimer
    toast.onmouseleave = Swal.resumeTimer
  },
})

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const state = reactive({
  session: {
    text: '',
    name: '',
    public_url: '',
    context: '',
  },
  botID: '',
  baseURL: '',
})

const getSession = async () => {
  state.botID = useCookie('botID')

  if (!state.botID) {
    const randomUppercase = String.fromCharCode(Math.floor(Math.random() * 26) + 65)
    const randomDigits = Math.random().toString().substring(2, 6)
    const randomString = randomUppercase + randomDigits

    state.botID = randomString
  }
  try {
    const res = await $api('allocate-text/'+route.params.id+'/'+state.botID, {
      method: 'GET',
      onResponseError({ response }) {
        console.log('response', response)
        // const errors = response._data.message
        const errors = response._data.message ? response._data.message : response._data.error
        Toast.fire({
          icon: "error",
          title: errors,
        })
      },
    })

    console.log(res)
    state.session = res
  } catch (error) {
    console.error('Request failed:', error)
  }
}

const getBaseUrl = async () => {
  try {
    const res = await $api('getImageBaseUrl', {
      method: 'GET',
      onResponseError({ response }) {
        console.log(response._data.errors)
      },
    })

    state.baseURL = res
  } catch (error) {
    console.error('Request failed:', error)
  }
}

onMounted(() => {
  getBaseUrl()
  getSession()
})
</script>

<template>
  <VContainer>
    <div class="fo-textbtn-area-holder">
      <VCard class="mb-6">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="12"
            >
              <div class="fo-textbtn-area">
                <!-- <RouterLink
                  :to="'/s/text/'+state.botID"
                  class=""
                >
                  <VBtn>
                    TEXT
                  </VBtn>
                </RouterLink> -->
                <a :href="state.baseURL+'/share/'+route.params.id+'/'+state.botID"> 
                  <VBtn>
                    TEXT
                  </VBtn>
                </a>
                <RouterLink
                  :to="'/s/identify/'+state.botID+'?s='+route.params.id"
                  class=""
                >
                  <VBtn class="fo-grey">
                    IDENTITY
                  </VBtn>
                </RouterLink>
              </div>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </div>
  </VContainer>
</template>
